import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ValidationTypes, ValidationMessage as ValidationMessageItem } from "../../utils/Validation";

const ValidationMessage = props => {
  const { message } = props;

  let classType;

  switch (message.type) {
    case ValidationTypes.INFO:
      classType = "validation-message-info";
      break;
    case ValidationTypes.WARNING:
      classType = "validation-message-warning";
      break;
    case ValidationTypes.ERROR:
      classType = "validation-message-error";
      break;
    default:
      classType = "validation-message-info";
      break;
  }

  return <div className={classNames("validation-message", classType)}>{message.message}</div>;
};

ValidationMessage.propTypes = {
  message: PropTypes.instanceOf(ValidationMessageItem),
};

export default ValidationMessage;
